import { useState } from 'react';
import AudienceAgeStatsComponent from '../../Influencers/Campaign/Details/AudienceAgeStatsComponent';
import AudienceCityStatsComponent from '../../Influencers/Campaign/Details/AudienceCityStatsComponent';
import AudienceCountryStatsComponent from '../../Influencers/Campaign/Details/AudienceCountryStatsComponent';
import AudienceGenderStatsComponent from '../../Influencers/Campaign/Details/AudienceGenderStatsComponent';
import FollowersStatsComponent from '../../Influencers/Campaign/Details/FollowersStatsComponent';
import ImpressionsStatsComponent from '../../Influencers/Campaign/Details/ImpressionsStatsComponent';
import ReachStatsComponent from '../../Influencers/Campaign/Details/ReachStatsComponent';
import SocialPostComponent from '../../Influencers/Profile/SocialPostComponent';
import EmptyInfluencerComponent from '../InfluencerList/EmptyInfluencerComponent';
import './ProfileAboutComponent.styles.scss';

const ProfileAboutComponent = ({
  about,
  age,
  address,
  languages,
  interests,
  gender,
  post = [],
  followersChnage = [],
  reachStats = [],
  impressionsStats = [],
  genderStats = [],
  ageStats = [],
  cityStats = [],
  countryStats = [],
}) => {
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const topPosts = [];
  // post && post.sort((a, b) => {
  //   return ((b.like_count+b.comments_count) - (a.like_count+a.comments_count));
  // }).slice(0, 5) || [];

  const recentPosts = [];
  // post && post.sort((a, b) => {
  //   return new Date(b.timestamp) - new Date(a.timestamp);
  // }).slice(0, 5) || [];

  return (
    <div className="col-md-12 px-2">
      <div className="common_card p-3 profile_about_card h-100">
        <div className="row">
          <div className="col-md-5">
            <div className="profile_about_card--info">
              <h5>About </h5>
              <p>{about}</p>
            </div>
          </div>
          <div className="col-md-7">
            <div className="profile_about_card_dem">
              <h5>Demographics</h5>
              <table className="table table-bordered">
                <tbody>
                  <tr>
                    <td>Location</td>
                    <td>{address?.city} {address?.country}</td>
                  </tr>
                  <tr>
                    <td>Gender</td>
                    <td>{gender?.toUpperCase()}</td>
                  </tr>
                  <tr>
                    <td>Age</td>
                    <td>{age}</td>
                  </tr>
                  <tr>
                    <td>Languages</td>
                    <td>{languages?.join(', ')}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{`${address?.line1}, ${address?.line2}, ${address?.city} - ${address?.pin}, ${address?.country}` }</td>
                  </tr>
                  <tr>
                    <td>Interests</td>
                    <td>
                      {
                        interests && interests.length ?
                          interests.map((interest, index) => (
                            <>
                              <span key={interest}>{capitalize(interest)}</span>
                              {index !==(interests.length -1)? ', ':' '}
                            </>
                          )):
                          'N/A'
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          { topPosts && topPosts.length > 0 && (
            <div className="col-md-12">
              <div className="common_card mt-3 over_progress_multi p-3">
                <h6 className="pb-2"><strong>Popular Posts</strong></h6>
                <div className="d-flex pb-2"
                  style={{ justifyContent: 'space-between', minWidth: '250px', gap: 20, overflowX: 'scroll' }}>
                  {topPosts && topPosts.length ?
                    topPosts.map((post) =><SocialPostComponent post={post}/> ):
                    <EmptyInfluencerComponent>Please link your social paltform to see the popular posts.</EmptyInfluencerComponent>
                  }
                </div>
              </div>
            </div>
          )}
          {
            recentPosts && recentPosts.length > 0 && (
              <div className="col-md-12">
                <div className="common_card mt-3 over_progress_multi p-3">
                  <h6 className="pb-2"><strong>Recent Posts</strong></h6>
                  <div className="d-flex pb-2"
                    style={{ justifyContent: 'space-between', minWidth: '250px', gap: 20, overflowX: 'scroll' }}>
                    {recentPosts && recentPosts.length ?
                      recentPosts.map((post) => <SocialPostComponent post={post}/> ):
                      <EmptyInfluencerComponent>Please link your social paltform to see the recent posts.</EmptyInfluencerComponent>
                    }
                  </div>
                </div>
              </div>
            )}

          {!!followersChnage && followersChnage.length > 0 && (
            <div className='col-md-6'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <FollowersStatsComponent followersChnage={followersChnage}/>
              </div>
            </div>
          )}
          { reachStats && reachStats.length > 0 && (
            <div className='col-md-6'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <ReachStatsComponent reachStats={reachStats}/>
              </div>
            </div>)
          }
          {impressionsStats && impressionsStats.length > 0 && (
            <div className='col-md-6'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <ImpressionsStatsComponent impressionsStats={impressionsStats}/>
              </div>
            </div>)
          }
          {genderStats && genderStats.length > 0 && (
            <div className='col-md-6'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <AudienceGenderStatsComponent genderStats={genderStats} />
              </div>
            </div>)
          }
          {countryStats && countryStats.length > 0 && (
            <div className='col-md-6'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <AudienceCountryStatsComponent countryStats={countryStats} />
              </div>
            </div>)
          }
          {cityStats && cityStats.length > 0 && (
            <div className='col-md-6'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <AudienceCityStatsComponent cityStats={cityStats}/>
              </div>
            </div>
          )}
          {ageStats && ageStats.length > 0 && (
            <div className='col-md-12'>
              <div className="common_card mt-3 over_progress_multi p-3">
                <AudienceAgeStatsComponent ageStats={ageStats}/>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileAboutComponent;
